module.exports = __webpack_public_path__ + "img/logo-nextpay.d61bd4dc.svg";